import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function SearchButton() {
	const navigate = useNavigate();

	const handleClick = () => {
		navigate("/products");
		// Use setTimeout to ensure the navigation is complete before trying to focus
		setTimeout(() => {
			const searchInput = document.querySelector(
				'input[type="text"][placeholder*="Search products"]'
			) as HTMLInputElement;
			if (searchInput) {
				searchInput.focus();
			}
		}, 100);
	};

	return (
		<>
			<Button
				variant="ghost"
				size="icon"
				onClick={handleClick}
				aria-label="Search">
				<Search className="h-5 w-5" />
			</Button>
		</>
	);
}
